module.exports = __webpack_public_path__ + "static/media/carousel_fr_AI.354784e5.jpg";